import { render, staticRenderFns } from "./oilAnd-grease.vue?vue&type=template&id=0d0ae8c0&scoped=true"
import script from "./oilAnd-grease.vue?vue&type=script&lang=js"
export * from "./oilAnd-grease.vue?vue&type=script&lang=js"
import style0 from "./oilAnd-grease.vue?vue&type=style&index=0&id=0d0ae8c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ae8c0",
  null
  
)

export default component.exports